import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { apiConstants } from '../../common/constants';
import { WEIGHT_V2_CONFIG_KEY, isWeightV2Merchant } from '../../../routes/weightV2Visibility';

const REPORT_API_ENDPOINT = `${apiConstants.MERCHANT_DETAILS}`
export const fetchReportData = createAsyncThunk(
    'config/merchant',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${apiConstants.BASE_LOCAL}${REPORT_API_ENDPOINT}/${id}`);
            return {
                reportData: response.data.reportsPiiDataEnabled,
                blendedData: response.data.blended,
                insuranceDetails: response.data.insuranceEnabled,
                orderConversionDetails: {
                    ...response.data.orderConversionCharges,
                    allocationVisibleMerchantPanel: response.data.allocationVisibleMerchantPanel,
                    rateCardVisibleMerchantPanel: response.data.rateCardVisibleMerchantPanel,
                    // Channel Orders / Returns default to VISIBLE — only an explicit `false`
                    // (admin toggled off) hides them, so existing merchants (field absent/null)
                    // keep access with no backend backfill.
                    channelOrdersVisibleMerchantPanel: response.data.channelOrdersVisibleMerchantPanel !== false,
                    returnsVisibleMerchantPanel: response.data.returnsVisibleMerchantPanel !== false,
                    showRvpQcToMerchant: response.data.showRvpQcToMerchant !== false,
                    // ProShip Direct master switch. OPT-IN: absent or false hides the whole
                    // module. Deliberately NOT given the `!== false` treatment the three above
                    // get — those are existing features that must stay visible for merchants
                    // whose config predates the flag; this is a new product that must stay
                    // HIDDEN until someone turns it on for a named merchant.
                    isProzoDirectEnabled: response.data.isProzoDirectEnabled,
                    // Weight v2 screens, OPT-IN like ProShip Direct: only a merchant whose weight
                    // engine mode is SHADOW or LIVE (production builds — see routes/weightV2Visibility.js).
                    [WEIGHT_V2_CONFIG_KEY]: isWeightV2Merchant(response.data.weightEngineMode)
                }
            };
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
